// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_30hNO","item":"_1XYHX"};


//////////////////
// WEBPACK FOOTER
// ./app/components/member-list/member-list-desktop.scss
// module id = 1599
// module chunks = 0